export default class Image {
  name;
  smallUrl;
  largeUrl;

  constructor(imageWire, shortNames) {
    this.name = shortNames ? imageWire.pc_nm : imageWire.picture_dto_name;
    this.smallUrl = shortNames ? imageWire.pc_su : imageWire.picture_dto_small_url;
    this.largeUrl = shortNames ? imageWire.pc_lu : imageWire.picture_dto_large_url;
  }
}
